module.exports = __webpack_public_path__ + "static/media/right-chev-purple.54a09bbc.svg";